import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { LANGUAGES } from '@/constants/languages';
import { downloadBase64File } from '@/lib/download';
import { useTRPC } from '@/trpc'
import { useQuery } from '@tanstack/react-query'
import * as Icon from 'lucide-react'

interface Props {
    offered_player_id: string;
}

const Overview = ({ offered_player_id }: Props) => {
    const { trpc } = useTRPC()

    const { data:offered_player } = useQuery({
        queryKey: ['player-offered', offered_player_id],
        queryFn: async () => {
            const player = await trpc.contacts.playersOffered.search.mutate({
                id: offered_player_id
            })
            return player[0]
        }
    })
    
  return (
    <div className='grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4'>
        <div>
            <Label>Position</Label>
            <p>{offered_player?.position}</p>
        </div>
        <div>
            <Label>Rol in positie</Label>
            <p>{offered_player?.role_position}</p>
        </div>
        <div>
            <Label>Telefoon</Label>
            <p>{offered_player?.telephone}</p>
        </div>
        <div>
            <Label>E-mail</Label>
            <p>{offered_player?.email}</p>
        </div>
        <div>
            <Label>Voor bedrijf</Label>
            <p>{offered_player?.company}</p>
        </div>
        <div>
            <Label>Transfer bedrag</Label>
            <p>{offered_player?.transfer_amount}</p>
        </div>
        <div>
            <Label>Salarisverwachting</Label>
            <p>{offered_player?.salary_expectation}</p>
        </div>
        <div>
            <Label>Talen</Label>
            <p>{offered_player?.languages?.map(l => LANGUAGES.find(lang=>lang.value === l)?.label).join(', ')}</p>
        </div>
        <div>
            <Label>Notitie</Label>
            <p>{offered_player?.note}</p>
        </div>
        <div>
            <Label>Externe url</Label>
            <p className='break-all'>{offered_player?.external_url}</p>
        </div>
        <div>
            <Label>Notitie</Label>
            <p>{offered_player?.note}</p>
        </div>
        <div>
            <Label>Extra info</Label>
            <p>{offered_player?.extra_info}</p>
        </div>
        {offered_player?.mandate &&
        <div className='flex flex-col gap-1'>
            <Label>Mandaat</Label>
            <Button 
                onClick={()=>{
                    downloadBase64File(offered_player.mandate!, `mandaat`)
                }}
                variant='outline'
            >
                <Icon.Download className='w-4 h-4'/>
                Download
            </Button>
        </div>
        }
    </div>
  )
}

export default Overview